module.exports = __webpack_public_path__ + "static/media/Empty.2bafb4e7.png";